export default __webpack_public_path__ + "static/media/570.8a2b385b.png";